import React, { memo, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Polygon } from "react-google-maps";
import { getList } from "actions/scooter/zones/actions";

const COLORS = {
  RIDE: {
    strokeColor: "#000",
    fillColor: "rgba(0, 0, 0, 0.5)"
  },
  FORBIDDEN: {
    strokeColor: "rgb(255, 0, 0)",
    fillColor: "rgba(255, 0, 0, 0.5)"
  },
  PARKING: {
    strokeColor: "rgb(0, 255, 0)",
    fillColor: "rgba(0, 255, 0, 0.5)"
  },
};

// eslint-disable-next-line react/display-name
const Zone = memo(props => {
  const {
    places,
    getList
  } = props;

  useEffect(() => {
    getList();
  }, [getList]);

  return places.map(place =>
    place.featureCollection.features.map(feature => feature.geometry.coordinates.map((coordinates, coordinatesIndex) =>
      <Polygon
        key={coordinatesIndex}
        options={{
          strokeOpacity: 0.5,
          ...(COLORS[place.type] || COLORS.RIDE)
        }}
        path={coordinates.map(coordinate => ({
          lat: coordinate[1],
          lng: coordinate[0]
        }))}/>)));
});

const mapStateToProps = state => ({
  places: state.scooterZones.list,
});

const mapStateToDispatch = dispatch => ({
  getList: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Zone);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/scooter/hot-map/zone.js